import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { AlterarDadoPessoalComponent } from './alterar-dado-pessoal.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
  ],
  exports: [
    AlterarDadoPessoalComponent
  ],
  declarations: [AlterarDadoPessoalComponent]
})
export class AlterarDadoPessoalComponentModule {
}
